import { render } from "./PriceField.vue?vue&type=template&id=b1dde886"
import script from "./PriceField.vue?vue&type=script&lang=js"
export * from "./PriceField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__